import domain from './domain';

// Reset model schemas
export const resetModelSchemas = domain.createEvent('resetModelSchemas');
